<template>
  <LayoutDashboard title="Formas de Pagamento">
    <v-card outlined>
      <v-card-title>
        <v-btn
          color="primary"
          @click="cadastrarFormaPagamento"
          outlined
          v-if="$helper.verificaPermissao('cadastrar-forma-pagamento')"
          >Cadastrar</v-btn
        >
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Pesquisar"
          single-line
          hide-details
          outlined
          dense
        >
        </v-text-field>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="getFormasPagamento"
          :search="search"
          dense
        >
          <template v-slot:item.action="{ item }">
            <v-btn
              color="primary"
              small
              @click="editar(item.id)"
              outlined
              v-if="$helper.verificaPermissao('visualizar-forma-pagamento')"
              >Visualizar</v-btn
            >
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </LayoutDashboard>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      search: "",
      headers: [
        { text: "#", value: "id", sortable: true },
        {
          text: "Descrição",
          align: "left",
          sortable: true,
          value: "nome",
        },
        {
          text: "Ordem de Exibição",
          align: "left",
          sortable: true,
          value: "ordem_exibicao",
          align:"center",
        },

        { text: "Ações", value: "action", sortable: false, align: "center"},
      ],
      formasPagamentos: [],
    };
  },
  computed: {
    ...mapGetters(["getFormasPagamento"]),
  },
  methods: {
    ...mapActions(["listarFormaPagamento", "cadastrarFormaPagamento"]),
    editar(item) {
      this.$router.push({ name: "formaPagamentoEditar", params: { id: item } });
    },
  },
  created() {
    this.listarFormaPagamento();
  },
};
</script>
